/*! @pentacode/ui v0.1.0 */
import { t as e } from "./decorate-DHgd5sZx.js";
import { t } from "./css-build-DICbZE45.js";
import { c as n, l as r, t as i } from "./chunk.UEBQI7VV-cl3cPog2.js";
import { a, c as o, i as s, l as c, n as l, o as u, r as d, s as f, t as p, u as m } from "./chunk.PZAN6FPN-NvFrxejO.js";
import { t as h } from "./chunk.F25QOBDY-D6vAKIyo.js";
import { css as g, html as _ } from "lit";
import { customElement as v, property as y, query as b, state as x } from "lit/decorators.js";
import { classMap as S } from "lit/directives/class-map.js";
//#region ../../node_modules/.pnpm/@awesome.me+webawesome@3.14.0_@floating-ui+utils@0.2.11_@types+node@24.19.2_@types+react@19.2.17/node_modules/@awesome.me/webawesome/dist/chunks/chunk.O62ZPKPP.js
var C = g`
  :host {
    --arrow-size: 0.375rem;
    --max-width: 25rem;
    --show-duration: var(--wa-transition-fast);
    --hide-duration: var(--wa-transition-fast);

    display: contents;

    /** Defaults for inherited CSS properties */
    font-size: var(--wa-font-size-m);
    line-height: var(--wa-line-height-normal);
    text-align: start;
    white-space: normal;
  }

  /* The native dialog element */
  .dialog {
    display: none;
    position: fixed;
    inset: 0;
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    border: none;
    background: transparent;
    overflow: visible;
    pointer-events: none;

    &:focus {
      outline: none;
    }

    &[open] {
      display: block;
    }
  }

  /* The <wa-popup> element */
  .popover {
    --arrow-size: inherit;
    --popup-border-width: var(--wa-panel-border-width);
    --show-duration: inherit;
    --hide-duration: inherit;

    pointer-events: auto;

    /* Inset box-shadow, not a border: Safari seams a clip-path edge that runs along a border. */
    &::part(arrow) {
      background-color: var(--wa-color-surface-default);
      border: none;
      box-shadow: inset calc(-1 * var(--wa-panel-border-width)) calc(-1 * var(--wa-panel-border-width)) 0 0
        var(--wa-color-surface-border);
    }
  }

  .popover[placement^='top']::part(popup) {
    transform-origin: bottom;
  }

  .popover[placement^='bottom']::part(popup) {
    transform-origin: top;
  }

  .popover[placement^='left']::part(popup) {
    transform-origin: right;
  }

  .popover[placement^='right']::part(popup) {
    transform-origin: left;
  }

  /* Body */
  .body {
    display: flex;
    flex-direction: column;
    width: auto;
    max-width: min(var(--max-width), 100vw);
    padding: var(--wa-space-l);
    background-color: var(--wa-color-surface-default);
    border: var(--wa-panel-border-width) solid var(--wa-color-surface-border);
    border-radius: var(--wa-panel-border-radius);
    border-style: var(--wa-panel-border-style);
    box-shadow: var(--wa-shadow-l);
    color: var(--wa-color-text-normal);
  }
`, w = /* @__PURE__ */ new Set(), T = class extends n {
	constructor() {
		super(...arguments), this.anchor = null, this.placement = "top", this.open = !1, this.distance = 8, this.skidding = 0, this.for = null, this.withoutArrow = !1, this.eventController = new AbortController(), this.pressStartedInside = !1, this.handleAnchorClick = () => {
			this.open = !this.open;
		}, this.handleBodyClick = (e) => {
			e.target.closest("[data-popover=\"close\"]") && (e.stopPropagation(), this.open = !1);
		}, this.handleDocumentKeyDown = (e) => {
			e.key === "Escape" && this.open && s(this) && (e.preventDefault(), e.stopPropagation(), this.open = !1, this.anchor && typeof this.anchor.focus == "function" && this.anchor.focus({ preventScroll: !0 }));
		}, this.handleDocumentPointerDown = (e) => {
			this.pressStartedInside = e.composedPath().includes(this);
		}, this.handleDocumentClick = (e) => {
			let t = this.pressStartedInside;
			this.pressStartedInside = !1, !t && (this.anchor && e.composedPath().includes(this.anchor) || e.composedPath().includes(this) || (this.open = !1));
		};
	}
	connectedCallback() {
		super.connectedCallback(), this.id ||= d("wa-popover-"), this.eventController.signal.aborted && (this.eventController = new AbortController()), this.for && this.anchor && (this.anchor = null, this.handleForChange());
	}
	disconnectedCallback() {
		super.disconnectedCallback(), document.removeEventListener("keydown", this.handleDocumentKeyDown), document.removeEventListener("pointerdown", this.handleDocumentPointerDown, { capture: !0 }), u(this), this.eventController.abort();
	}
	firstUpdated(e) {
		super.firstUpdated(e), this.open && (this.dialog.show(), this.popup.active = !0, this.popup.reposition());
	}
	updated(e) {
		e.has("open") && this.customStates.set("open", this.open);
	}
	async handleOpenChange() {
		if (this.open) {
			let e = new m();
			if (this.dispatchEvent(e), e.defaultPrevented) {
				this.open = !1;
				return;
			}
			w.forEach((e) => e.open = !1), document.addEventListener("keydown", this.handleDocumentKeyDown, { signal: this.eventController.signal }), document.addEventListener("pointerdown", this.handleDocumentPointerDown, {
				capture: !0,
				signal: this.eventController.signal
			}), document.addEventListener("click", this.handleDocumentClick, { signal: this.eventController.signal }), this.dialog.setAttribute("open", ""), this.popup.active = !0, w.add(this), a(this), requestAnimationFrame(() => {
				let e = this.querySelector("[autofocus]");
				e && typeof e.focus == "function" ? e.focus({ preventScroll: !0 }) : this.dialog.focus({ preventScroll: !0 });
			}), await l(this.popup.popup, "show-with-scale"), this.popup.reposition(), this.dispatchEvent(new f());
		} else {
			let e = new c();
			if (this.dispatchEvent(e), e.defaultPrevented) {
				this.open = !0;
				return;
			}
			document.removeEventListener("keydown", this.handleDocumentKeyDown), document.removeEventListener("pointerdown", this.handleDocumentPointerDown, { capture: !0 }), document.removeEventListener("click", this.handleDocumentClick), this.pressStartedInside = !1, w.delete(this), u(this), await l(this.popup.popup, "hide-with-scale"), this.popup.active = !1, this.dialog.close(), this.dispatchEvent(new o());
		}
	}
	handleForChange() {
		let e = this.getRootNode();
		if (!e) return;
		let t = this.for ? e.getElementById(this.for) : null, n = this.anchor;
		if (t === n) return;
		let { signal: r } = this.eventController;
		t && t.addEventListener("click", this.handleAnchorClick, { signal: r }), n && n.removeEventListener("click", this.handleAnchorClick), this.anchor = t, this.for && !t && console.warn(`A popover was assigned to an element with an ID of "${this.for}" but the element could not be found.`, this);
	}
	async handleOptionsChange() {
		this.hasUpdated && (await this.updateComplete, this.popup.reposition());
	}
	async show() {
		if (!this.open) return this.open = !0, h(this, "wa-after-show");
	}
	async hide() {
		if (this.open) return this.open = !1, h(this, "wa-after-hide");
	}
	render() {
		return _`
      <dialog part="dialog" class="dialog">
        <wa-popup
          part="popup"
          exportparts="
            popup:popup__popup,
            arrow:popup__arrow
          "
          class=${S({
			popover: !0,
			"popover-open": this.open
		})}
          placement=${this.placement}
          distance=${this.distance}
          skidding=${this.skidding}
          flip
          shift
          shift-padding="8"
          ?arrow=${!this.withoutArrow}
          .anchor=${this.anchor}
        >
          <div part="body" class="body" @click=${this.handleBodyClick}>
            <slot></slot>
          </div>
        </wa-popup>
      </dialog>
    `;
	}
};
T.css = C, T.dependencies = { "wa-popup": i }, r([b("dialog")], T.prototype, "dialog", 2), r([b(".body")], T.prototype, "body", 2), r([b("wa-popup")], T.prototype, "popup", 2), r([x()], T.prototype, "anchor", 2), r([y()], T.prototype, "placement", 2), r([y({
	type: Boolean,
	reflect: !0
})], T.prototype, "open", 2), r([y({ type: Number })], T.prototype, "distance", 2), r([y({ type: Number })], T.prototype, "skidding", 2), r([y()], T.prototype, "for", 2), r([y({
	attribute: "without-arrow",
	type: Boolean,
	reflect: !0
})], T.prototype, "withoutArrow", 2), r([p("open", { waitUntilFirstUpdate: !0 })], T.prototype, "handleOpenChange", 1), r([p("for")], T.prototype, "handleForChange", 1), r([p([
	"distance",
	"placement",
	"skidding"
])], T.prototype, "handleOptionsChange", 1), T = r([v("wa-popover")], T);
//#endregion
//#region \0lit-plugin:css-sheet:./src/elements/popover/popover.css.js
var E = t(":host{--_popover-surface:var(--popover-surface,var(--color-bg));--_popover-color:var(--popover-color,var(--color-fg));--_popover-border-color:var(--popover-border-color,var(--shade-2));--_popover-radius:var(--popover-radius,var(--radius-relative));--_popover-padding:var(--popover-padding,.8em);--_popover-shadow:var(--popover-shadow,0 0 3px #0003);--_popover-max-width:var(--popover-max-width,25rem);--_popover-min-width:var(--popover-min-width,0);--arrow-size:var(--popover-arrow-size,.375rem);--max-width:var(--_popover-max-width)}.body{background-color:var(--_popover-surface);color:var(--_popover-color);border-color:var(--_popover-border-color);border-radius:var(--_popover-radius);padding:var(--_popover-padding);box-shadow:var(--_popover-shadow);min-width:var(--_popover-min-width);display:block}.popover{--show-duration:var(--popover-show-duration,.15s);--hide-duration:var(--popover-hide-duration,.15s)}.popover::part(popup){filter:var(--popover-filter,none)}.popover::part(arrow){background-color:var(--_popover-surface);box-shadow:inset calc(-1 * var(--wa-panel-border-width)) calc(-1 * var(--wa-panel-border-width)) 0 0 var(--_popover-border-color)}"), D = class extends T {
	static get styles() {
		return [super.styles, E];
	}
};
D = e([v("ptc-ui-popover")], D);
var O = D;
//#endregion
export { O as n, D as t };

//# sourceMappingURL=popover-CCGu54Mc.js.map